import { useState } from 'react';
import {
    CREATE_APP_DATA_METAFIELD_MUTATION,
    CreateAppDataMetafieldResponse,
    MetafieldsSetInput,
} from 'hooks/shopify/queries/create-app-data-metafield.graphql';
import {
    GET_CURRENT_APP_INSTALLATION_QUERY,
    GetCurrentAppInstallationResponse,
} from 'hooks/shopify/queries/get-current-app-installation.graphql';
import { shopifyGraphQL } from 'hooks/shopify/shopify-graphql';

interface UseSetAppMetafieldReturn {
    setMetafield: (metafield: Omit<MetafieldsSetInput, 'ownerId'>) => Promise<CreateAppDataMetafieldResponse>;
    isSetting: boolean;
}

export const useSetAppMetafield = (): UseSetAppMetafieldReturn => {
    const [isSetting, setIsSetting] = useState(false);

    const setMetafield = async (metafield: Omit<MetafieldsSetInput, 'ownerId'>) => {
        setIsSetting(true);
        try {
            const { currentAppInstallation } = await shopifyGraphQL<GetCurrentAppInstallationResponse>(
                GET_CURRENT_APP_INSTALLATION_QUERY
            );
            return await shopifyGraphQL<CreateAppDataMetafieldResponse>(CREATE_APP_DATA_METAFIELD_MUTATION, {
                metafieldsSetInput: [{ ...metafield, ownerId: currentAppInstallation.id }],
            });
        } finally {
            setIsSetting(false);
        }
    };

    return { setMetafield, isSetting };
};
